/* eslint-disable react-hooks/exhaustive-deps */
// import { useToast } from "@/hooks/use-toast";
import { GenericType } from "@/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: GenericType;
  onFormSubmit: (prop: GenericType) => Promise<GenericType>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  company_id: z.string().min(1, {
    message: "Company id is required.",
  }),
  display_name: z.string().min(1, {
    message: "Display name required.",
  }),
  snc_company_id: z.string().optional(),
  country: z.string().optional(),
  show_deleted_documents: z.boolean().optional(),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      company_id: "",
      display_name: "",
      snc_company_id: "",
      country: "",
      show_deleted_documents: false,
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      // country and show_deleted_documents are stored inside settings
      const values = { ...formData, ...(formData.settings || {}) };
      schemaKeys.forEach((key) => {
        if (values[key]) {
          form.setValue(key, values[key], {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data } = await onFormSubmit(values);
    if (data) {
      // toast({
      //   title: "Success",
      //   variant: "success",
      //   description: data.status.msg,
      // });
      onOpenChange(false);
    }
  }

  return { form, onSubmit };
};
